import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Handleapprove(state = initialState, action) {
  switch (action.type) {
    case userConstants.HANDLEAPPROVEFORM_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.HANDLEAPPROVEFORM_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.HANDLEAPPROVEFORM_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}